export const RightArrow = ({
  width = '24',
  height = '24',
  fill = '#DA291C',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1828_4073)">
        <path
          d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1828_4073">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 -1 24 24)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownArrow = ({
  width = '24',
  height = '24',
  fill = '#1F1F1F',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41 8.59L6 10L12 16L18 10L16.59 8.59L12 13.17L7.41 8.59Z"
        fill={fill}
      />
    </svg>
  );
};
